import * as types from './actionTypes';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
  loading: true,
  cities : []
});

export default function reduce(state = initialState, action = {}) {
  switch (action.type) {
    case types.LOADING:
      return {
        ...state,
        loading: true,
      };
    case types.LOADED:
      return {
        ...state,
        loading: false,
        cities: action.cities,
        homeCity: action.homeCity,
        citiesGot: action.citiesGot,
        user: action.user,
        cuisines: action.cuisines,
        cuisineNames: action.cuisineNames,
        contributors: action.contributors
      };
    default:
      return state;
  }
}

//Selectors
export function getValue(state, key) {
  const value = state["addEditContributor"][key];
  switch (key) {
    default:
      return value;
  }
}

export function getAllValues(state, key) {
  return state["addEditContributor"];
}
